/* tslint:disable */
/* eslint-disable */
/**
 * OiOi content management API
 * OiOi content management API spec
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    KeyValueProperty,
    KeyValuePropertyFromJSON,
    KeyValuePropertyFromJSONTyped,
    KeyValuePropertyToJSON,
    ResourceType,
    ResourceTypeFromJSON,
    ResourceTypeFromJSONTyped,
    ResourceTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface Resource
 */
export interface Resource {
    /**
     * Resource id.
     * @type {string}
     * @memberof Resource
     */
    readonly id?: string;
    /**
     * Resource parent id.
     * @type {string}
     * @memberof Resource
     */
    parentId?: string;
    /**
     * 
     * @type {number}
     * @memberof Resource
     */
    orderNumber?: number;
    /**
     * 
     * @type {ResourceType}
     * @memberof Resource
     */
    type: ResourceType;
    /**
     * 
     * @type {Array<KeyValueProperty>}
     * @memberof Resource
     */
    styles?: Array<KeyValueProperty>;
    /**
     * 
     * @type {Array<KeyValueProperty>}
     * @memberof Resource
     */
    properties?: Array<KeyValueProperty>;
    /**
     * Resource display name.
     * @type {string}
     * @memberof Resource
     */
    name: string;
    /**
     * Resource data, either URL on images, videos, etc and text data on text resources
     * @type {string}
     * @memberof Resource
     */
    data?: string;
    /**
     * Resource slug name.
     * @type {string}
     * @memberof Resource
     */
    slug: string;
    /**
     * Creation time
     * @type {Date}
     * @memberof Resource
     */
    readonly createdAt?: Date;
    /**
     * Last modification time
     * @type {Date}
     * @memberof Resource
     */
    readonly modifiedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    creatorId?: string;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    lastModifierId?: string;
}

export function ResourceFromJSON(json: any): Resource {
    return ResourceFromJSONTyped(json, false);
}

export function ResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Resource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'parentId': !exists(json, 'parentId') ? undefined : json['parentId'],
        'orderNumber': !exists(json, 'orderNumber') ? undefined : json['orderNumber'],
        'type': ResourceTypeFromJSON(json['type']),
        'styles': !exists(json, 'styles') ? undefined : ((json['styles'] as Array<any>).map(KeyValuePropertyFromJSON)),
        'properties': !exists(json, 'properties') ? undefined : ((json['properties'] as Array<any>).map(KeyValuePropertyFromJSON)),
        'name': json['name'],
        'data': !exists(json, 'data') ? undefined : json['data'],
        'slug': json['slug'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'modifiedAt': !exists(json, 'modifiedAt') ? undefined : (new Date(json['modifiedAt'])),
        'creatorId': !exists(json, 'creatorId') ? undefined : json['creatorId'],
        'lastModifierId': !exists(json, 'lastModifierId') ? undefined : json['lastModifierId'],
    };
}

export function ResourceToJSON(value?: Resource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parentId': value.parentId,
        'orderNumber': value.orderNumber,
        'type': ResourceTypeToJSON(value.type),
        'styles': value.styles === undefined ? undefined : ((value.styles as Array<any>).map(KeyValuePropertyToJSON)),
        'properties': value.properties === undefined ? undefined : ((value.properties as Array<any>).map(KeyValuePropertyToJSON)),
        'name': value.name,
        'data': value.data,
        'slug': value.slug,
        'creatorId': value.creatorId,
        'lastModifierId': value.lastModifierId,
    };
}


